import { useCallback } from 'react';
import cl from 'classnames';

import { Checkbox } from '../../../../../../../../../helpers/Checkbox';

interface ThreeDStockProductsFiltersAiTagsFilterItemTag {
  name: string;
}

interface ThreeDStockProductsFiltersAiTagsFilterItemProps {
  tag: ThreeDStockProductsFiltersAiTagsFilterItemTag;
  onCheckedTag: (tagName: string, checked: boolean) => void;
  checked: boolean;
  isCompact?: boolean;
}

function ThreeDStockProductsFiltersAiTagsFilterItem({
  onCheckedTag,
  tag,
  checked,
  isCompact
}: ThreeDStockProductsFiltersAiTagsFilterItemProps) {
  const handleCheck = useCallback(
    (checked: boolean) => {
      onCheckedTag(tag.name, checked);
    },
    [onCheckedTag, tag]
  );

  return (
    <li className={isCompact ? 'py-0.5' : 'py-1'}>
      <Checkbox
        dataGa={`tag-${tag.name}`}
        checkboxWrapperClassName="flex items-center"
        checkboxClassName={isCompact ? 'basic-checkbox h-3.5 w-3.5' : undefined}
        labelClassName={cl(
          'ml-2 block text-gray-900 dark:text-gray-100 truncate',
          isCompact ? 'text-xs' : 'text-sm'
        )}
        label={tag.name}
        checked={checked}
        onChange={handleCheck}
      />
    </li>
  );
}

export default ThreeDStockProductsFiltersAiTagsFilterItem;
